import App from '@/models/App'
import Profile from '@/models/Profile'
import Organization from '@/models/Organization'
import ShipSailorInfo from '@/models/ShipSailorInfo'
import ShipLaborWork from '@/models/ShipLaborWork'
import ShipLaborBoarding from '@/models/ShipLaborBoarding'
import { date2YMDHMS } from '@/utility/Date'

export default class ShipSailor extends App {
    static get entity() {
        return 'ShipSailors'
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            userId: this.attr(''),
            shipLaborWorkId: this.attr(''),
            attendancedAt: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            organization: this.belongsTo(Organization, 'organizationId'),
            profile: this.belongsTo(Profile, 'userId'),
            shipSailorInfo: this.hasOne(ShipSailorInfo, 'shipSailorId', 'id'),
            shipLaborWork: this.belongsTo(ShipLaborWork, 'shipLaborWorkId'),
            latestShipLaborBoarding: this.attr(''),
            shipLaborBoardings: this.hasMany(
                ShipLaborBoarding,
                'shipSailorId',
                'id'
            ),
        }
    }
    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }
    static findBySailorId(sailorId) {
        return this.query()
            .withAllRecursive()
            .get()
            .find((sailor) => sailor.shipSailorInfo.shipSailorId === sailorId)
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static onboard() {
        const nowDate = date2YMDHMS(new Date())
        return this.all().filter((sailor) => {
            if (sailor.latestShipLaborBoarding === null) {
                return false
            }
            const { isDisembarked, disembarkAt } =
                sailor.latestShipLaborBoarding
            if (isDisembarked) {
                return false
            }
            if (disembarkAt && disembarkAt < nowDate) {
                return false
            }
            return true
        })
    }
    static apiConfig = {
        actions: {
            fetch(shipId, isAll) {
                return this.get(`/${shipId}/sailors`, {
                    params: {
                        all: isAll,
                    },
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            list(shipId, isAll, page = 'all') {
                return this.get(`/${shipId}/v2/sailors`, {
                    params: {
                        all: isAll,
                        page: page
                    },
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            find(shipId, sailorId) {
                return this.get(`/${shipId}/sailors/${sailorId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'sailor',
                    baseURL: App.apiURL(),
                })
            },
            create(shipId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.post(`/${shipId}/sailors`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            updateUser(params) {
                App.renewalSnackbar(); return Promise.resolve();
                const { userId, firstName, lastName, employeeNo } = params
                return this.patch(
                    `/user/${userId}`,
                    App.patch({ firstName, lastName, employeeNo }),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                        save: false,
                    }
                )
            },
        },
    }
}
